import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { SupplierApiCall } from '../../../supplier-api-tester.models';
import { ApiTesterActionDialogComponent, ApiTesterActionDialogData } from './api-tester-action-dialog.component';

/**
 * Déroulé commun des actions d'écriture du parcours guidé : confirmation avec aperçu de l'appel,
 * envoi, puis message de résultat. N'émet rien si le testeur annule.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiTesterActionService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
  ) {}

  run<T>(
    data: ApiTesterActionDialogData,
    execute: (body: Record<string, unknown>) => Observable<SupplierApiCall<T>>,
  ): Observable<SupplierApiCall<T>> {
    return this.dialog
      .open<ApiTesterActionDialogComponent, ApiTesterActionDialogData, Record<string, unknown>>(
        ApiTesterActionDialogComponent,
        { data, width: '560px' },
      )
      .afterClosed()
      .pipe(
        filter(body => !!body),
        switchMap(body => execute(body)),
        tap(call => {
          const message = call.ok
            ? `${data.title} : accepté par l'API (HTTP ${call.status})`
            : `Refusé par l'API (HTTP ${call.status || 'aucune réponse'}) : ${call.errorMessage}`;
          this.snackBar.open(message, 'Fermer', { duration: call.ok ? 3000 : 8000 });
        }),
      );
  }
}
